import React from 'react'
import SortableItemUI from './SortableItemUI'

// for the moment, this component doesn't necessarily have to
// handle state all by itself, but we could potentially have a
// generic data handler/reducer for this, with different instances,
// like the hypothesized addOrEdit instances

const Sortable = ({
  className,
  data,
  emptyItemUI,
  idField,
  itemUI,
  moveItem,
}) => {
  return (
    <div className={className || null}>
      {data.map((el, idx) => (
        <SortableItemUI
          id={el.id}
          text={el.text}
          index={idx}
          key={el[idField]}
          itemUI={itemUI}
          moveItem={moveItem}
        />
      ))}
    </div>
  )
}

export default Sortable
